import React from "react";
import styled, { css } from "styled-components";
import * as colors from "../settings/colors";

export const STATUS_TEXT = {
  draft: "Draft",
  awaiting_review: "Awaiting Review",
  open: "Open",
  in_production: "Production",
  on_hold: "Hold",
  pending_approval: "Pending Approval",
  closed: "Complete",
  cancelled: "Cancelled"
};

const StatusLabel = ({
  color,
  size,
  status,
  inverse,
  text,
  children,
  ...otherProps
}) => {
  const statusText = STATUS_TEXT[status];
  return (
    <span {...otherProps}>
      {typeof children === "function"
        ? children({ statusText })
        : children || text || statusText}
    </span>
  );
};

const StyledStatusLabel = styled(StatusLabel)`
  display: inline-block;
  font-size: 11px;
  line-height: 1;
  font-weight: 600;
  color: #fff;
  background: ${props =>
    props.color ||
    (props.status && colors.STATUS_COLOR[props.status]) ||
    colors.TAB_TEXT};
  padding: 4px 7px;
  border-radius: 3px;
  margin: 2px 4px 2px 0;

  ${({ size }) =>
    size === "large" &&
    css`
      font-size: 12px;
      line-height: 23px;
      padding: 0 10px;
    `} ${({ inverse }) =>
    inverse &&
    css`
      color: ${colors.TEXT};
      background: white;
    `};
`;

export default StyledStatusLabel;



// WEBPACK FOOTER //
// ./src/components/StatusLabel.js